import styled from 'styled-components';
import Table from '@decisiv/ui-components/lib/components/Table';

const NoWrapHeaderTable = styled(Table)`
  && {
    table thead th div {
      white-space: nowrap;
    }
  }
` as typeof Table;

export default NoWrapHeaderTable;
